'use strict';
import '../plugins/slickPlugin';
import $ from 'jquery';

export default class M92 {
  static init() {
    $('.module-m92').each((index, el) => {
      new M92($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    const self = this;
    this.el.find('.testimonialSlider').each(function () {
      let $module = $(this);
      let options = {
        dots: false,
        variableWidth: true,
        // waitForAnimate: false,
        infinite: true,
        arrows: true,
        centerMode: true,
        appendArrows: $module.siblings('.slick-arrows'),
      };
      if (self.el.hasClass('theme-dark')) {
        options.prevArrow = '<button class="slick-prev slick-arrow-teal"></button>';
        options.nextArrow = '<button class="slick-next slick-arrow-teal"></button>';
      }
      if ($module.hasClass('auto-slide')) {
        options.autoplay = true;
        options.autoplaySpeed = $module.data('slide-speed');
        options.pauseOnFocus = false;
      }
      $module.slick(options);
    });
  }
}
